// Google Maps Component - Module Pattern
(function() {
    'use strict';
    
    class GoogleMapsACF {
        constructor() {
            this.maps = [];
        }

        init(elements) {
            this.elements = Array.isArray(elements) ? elements : [elements];
            console.log('Initializing Google Maps for', this.elements.length, 'elements');
            
            // Check if Google Maps API is loaded
            if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
                console.error('Google Maps API not loaded yet. Retrying...');
                setTimeout(() => this.init(elements), 100);
                return;
            }
            
            this.elements.forEach(element => {
                this.initMap(element);
            });
        }

        initMap(el) {
            // Use vanilla JS instead of jQuery
            const markers = el.querySelectorAll('.marker');
            
            // Your Snazzy Maps style
            const styles = [
                {
                    "featureType": "all",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {"saturation": 36},
                        {"color": "#000000"},
                        {"lightness": 40}
                    ]
                },
                {
                    "featureType": "all",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {"visibility": "on"},
                        {"color": "#000000"},
                        {"lightness": 16}
                    ]
                },
                {
                    "featureType": "all",
                    "elementType": "labels.icon",
                    "stylers": [
                        {"visibility": "off"}
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {"color": "#000000"},
                        {"lightness": 20}
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {"color": "#000000"},
                        {"lightness": 17},
                        {"weight": 1.2}
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "geometry",
                    "stylers": [
                        {"color": "#000000"},
                        {"lightness": 20}
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [
                        {"color": "#000000"},
                        {"lightness": 21}
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {"color": "#9a8858"},
                        {"lightness": 17},
                        {"visibility": "on"}
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {"color": "#000000"},
                        {"lightness": 29},
                        {"weight": 0.2}
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "geometry",
                    "stylers": [
                        {"color": "#000000"},
                        {"lightness": 18}
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "geometry",
                    "stylers": [
                        {"color": "#000000"},
                        {"lightness": 16}
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "geometry",
                    "stylers": [
                        {"color": "#000000"},
                        {"lightness": 19}
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {"color": "#000000"},
                        {"lightness": 17}
                    ]
                }
            ];
            
            const mapArgs = {
                zoom: parseInt(el.dataset.zoom) || 16,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                mapTypeControl: false,
                gestureHandling: 'cooperative'
            };
            
            const map = new google.maps.Map(el, mapArgs);
            
            map.markers = [];
            
            markers.forEach(marker => {
                this.initMarker(marker, map);
            });
            
            this.centerMap(map);
            
            this.maps.push(map);
        }

        initMarker(markerEl, map) {
            const lat = markerEl.dataset.lat;
            const lng = markerEl.dataset.lng;
            const latLng = {
                lat: parseFloat(lat),
                lng: parseFloat(lng)
            };
            
            const marker = new google.maps.Marker({
                position: latLng,
                map: map,
                icon: {
                    url: '/wp-content/themes/exitedfounders/images/site_icon.png',
                    scaledSize: new google.maps.Size(40, 40), // Adjust size as needed
                    anchor: new google.maps.Point(20, 40) // Center point (half width, full height for bottom-centered)
                }
            });
            
            map.markers.push(marker);
            
            if(markerEl.innerHTML.trim()) {
                const infowindow = new google.maps.InfoWindow({
                    content: markerEl.innerHTML
                });
                
                google.maps.event.addListener(marker, 'click', function() {
                    infowindow.open(map, marker);
                });
            }
        }

        centerMap(map) {
            const bounds = new google.maps.LatLngBounds();
            
            map.markers.forEach(function(marker) {
                bounds.extend({
                    lat: marker.position.lat(),
                    lng: marker.position.lng()
                });
            });
            
            if(map.markers.length == 1) {
                map.setCenter(bounds.getCenter());
            } else {
                map.fitBounds(bounds);
            }
        }

        refresh() {
            this.maps = [];
            this.init(this.elements);
        }
    }

    // Export the component for the component loader
    const googleMapsComponent = {
        init: function(elements) {
            const mapsInstance = new GoogleMapsACF();
            mapsInstance.init(elements);
            
            // Store instance globally for manual access if needed
            if (!window.googleMapsInstances) {
                window.googleMapsInstances = [];
            }
            window.googleMapsInstances.push(mapsInstance);
        }
    };

    // Call the global initialization function that the component loader sets up
    if (typeof window.init_google_map === 'function') {
        window.init_google_map(googleMapsComponent);
    }

})();